// extracted by mini-css-extract-plugin
export default {"characterBuilder":"styles_characterBuilder__-atY5"};